<a class="wish" (click)="goFavorites()">
    <i class="fa fa-heart"></i>
</a>
<span class="tooltip-text">wishlist</span>